import { StyleSheet } from 'aphrodite';
import { background, header, mention, titles, white } from '../../web/styles/colors';
import { BreakPoints, truncateTextStyle } from '../../web/styles/styles';

export const MobileBreakpoint = 720;

export const styleSheet = StyleSheet.create({
	background: {
		alignItems: 'flex-start',
		background: white,
		display: 'flex',
		justifyContent: 'center',
		minHeight: '100vh',
		padding: '75px 0 40px',
		width: '100%',
		[BreakPoints.forMaxWidth(MobileBreakpoint)]: {
			background: white,
			paddingTop: 0,
		},
	},
	container: {
		background: white,
		border: '1px solid #C6CCD7',
		borderRadius: 8,
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		maxWidth: 920,
		position: 'relative',
		[BreakPoints.forMaxWidth(MobileBreakpoint)]: {
			border: 'none',
			borderRadius: 0,
		},
	},
	errorIcon: {
		display: 'block',
		margin: 'auto',
	},
	errorText: {
		color: '#fff',
		fontSize: 18,
		marginTop: 12,
		textAlign: 'center',
		[BreakPoints.forMaxWidth(MobileBreakpoint)]: {
			color: '#000',
		},
	},
	header: {
		background,
		borderTopLeftRadius: 8,
		borderTopRightRadius: 8,
		boxShadow: `0 0 6px 0 rgba(139, 139, 139, 0.20) inset`,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		minHeight: 180,
		position: 'relative',
		paddingTop: 16,
		paddingBottom: 16,
		[BreakPoints.forMaxWidth(768)]: {
			flexDirection: 'column',
			padding: '0 30px',
		},
		[BreakPoints.forMaxWidth(MobileBreakpoint)]: {
			borderTopLeftRadius: 0,
			borderTopRightRadius: 0,
			minHeight: 170,
		},
	},
	headerCol: {
		flexBasis: '50%',
		padding: '45px 30px 0',
		position: 'relative',
		textAlign: 'center',
		[BreakPoints.forMaxWidth(768)]: {
			padding: '15px 30px',
		},
	},
	headerColLeft: {
		flex: '1 0 50%',
	},
	headerColRight: {
		textAlign: 'left',
		[BreakPoints.forMaxWidth(768)]: {
			alignItems: 'center',
			borderTop: `1px solid var(--scheduler-accent-tint, ${mention})`,
			display: 'flex',
			flexDirection: 'column',
			textAlign: 'center',
		},
	},
	hide: {
		display: 'none',
	},
	inputLabel: {
		colors: titles,
		display: 'block',
		fontSize: 14,
		paddingBottom: 4,
	},
	label: {
		...truncateTextStyle,
		color: header,
		fontSize: 14,
		margin: 0,
	},
	pill: {
		background: `var(--scheduler-accent-tint, ${mention})`,
		borderRadius: 50,
		padding: '9px 19px',
	},
	text: {
		fontSize: 16,
		margin: 0,
	},
	sharedBackgroundWrapper: {
		alignItems: 'center',
		background: white,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		padding: '75px 0 40px',
		width: '100%',
		flex: 1,
		[BreakPoints.forMaxWidth(MobileBreakpoint)]: {
			padding: 0,
		},
	},
	sharedBackgroundWrapperMobileNoCustom: {
		[BreakPoints.forMaxWidth(MobileBreakpoint)]: {
			padding: 0,
		},
	},
});
